import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconYen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"yen, currency, money, coin"} maskId="square-filled-radius-0-stroke-1-IconYen"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8.54704 7.29446L7.79446 7.95296L11.3356 12H9V13H11.5V14H9V15H11.5V18H12.5V15H15V14H12.5V13H15V12H12.6644L16.2055 7.95296L15.453 7.29446L12 11.2407L8.54704 7.29446Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconYen;
